import * as Sentry from "@sentry/tanstackstart-react";
import { createRouter } from "@tanstack/react-router";
import { PostHogProvider } from "posthog-js/react";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
export const getRouter = () => {
	const router = createRouter({
		routeTree,
		scrollRestoration: true,
		defaultPreloadStaleTime: 0,
		Wrap: ({ children }) => {
			// Check for analytics consent
			const analyticsConsent =
				typeof window !== "undefined"
					? localStorage.getItem("analytics_consent")
					: null;

			return (
				<PostHogProvider
					apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
					options={{
						api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
						defaults: "2025-05-24",
						capture_exceptions: true,
						// debug: import.meta.env.MODE === "development",
						disable_session_recording: true,
						// Only use cookieless mode if analytics consent is rejected
						cookieless_mode:
							analyticsConsent === "rejected" ? "on_reject" : undefined,
						debug: import.meta.env.VITE_APP_ENV !== "production",
						// Enable automatic page view tracking
						capture_pageview: true,
					}}
				>
					{children}
				</PostHogProvider>
			);
		},
	});

	if (!router.isServer) {
		Sentry.init({
			dsn: import.meta.env.VITE_SENTRY_DSN,
			sendDefaultPii: true,
			orgId: import.meta.env.VITE_SENTRY_ORG_ID,
			integrations: [],
		});
	}

	return router;
};
